module.exports = __webpack_public_path__ + "img/slika60.09ee4177.jpg";